export async function extractApiErrorMessage(response: Response): Promise<string> {
  const errorBody = await response.json().catch(() => null);
  return (
    (errorBody as { message?: string } | null)?.message ??
    `HTTP error! status: ${response.status}`
  );
}
